import PropTypes from 'prop-types';
import { resolve } from 'library/helpers/path-resolver';
import React, { Fragment } from 'react';
import AdjectiveBody from 'apps/survey/components/versions/list/adjective-body';
import Checkbox from 'library/components/form-elements/checkbox';

class AdjectiveRow extends React.PureComponent {
  static propTypes = {
    name: PropTypes.string,
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    definition: PropTypes.string,
    audio_key: PropTypes.string,
    real: PropTypes.bool,
    ideal: PropTypes.bool,
    state: PropTypes.oneOf(['ideal', 'real']),
    onChange: PropTypes.func,
    showModal: PropTypes.func,
    referenceReal: PropTypes.any,
    referenceIdeal: PropTypes.any,
    first: PropTypes.bool
  }

  static defaultProps = {
    first: false
  }

  render() {
    const {
      name,
      id,
      definition,
      audio_key,
      onChange,
      state,
      real,
      ideal,
      showModal,
      referenceReal,
      referenceIdeal,
      first
    } = this.props;

    return (
      <div className="survey-version-list-row">
        <Checkbox
          aria-label={`Real ${name}`}
          id={`adjective_real_${id}`}
          checked={real}
          name={`real.${id}`}
          onChange={onChange}
          onFocus={this.handleFocus}
          modal
          showModal={showModal}
          reference={referenceReal}
          first={first}
        />
        <div className="survey-version-list-row-checkbox-spacer" />
        <AdjectiveBody checked={real} name={name} audio_key={audio_key} definition={definition} />
        {
          state!=='real'
            ? (
              <Fragment>
                <div className="survey-version-list-row-checkbox-spacer last-child" />
                <Checkbox
                  first={first}
                  reference={referenceIdeal}
                  aria-label={`Ideal ${name}`}
                  id={`adjective_ideal_${id}`}
                  checked={ideal}
                  name={`ideal.${id}`}
                  onChange={onChange}
                />
              </Fragment>
            ) : null
        }
      </div>
    );
  }
}

export default AdjectiveRow;
